import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';

@Component({
  selector: 'app-employee-summary',
  templateUrl: './employee-summary.component.html',
  styleUrls: ['./employee-summary.component.css']
})
export class EmployeeSummaryComponent implements OnInit {
  states: any;
  data: any = {
    firstName: '',
    middleName: '',
    lastName: '',
    employeeType: '',
    bcDate: '',
    employeeAddress: '',
    employeeCity: '',
    employeeState: '',
    employeeZip: '',
  }
  employeeDetails: any;
  errMsg;
  errFlag: boolean = false;
  DbId: any;
  submitSuccess;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  message;
  id: any;
  editList: any;
  private subscription: any;
  public fxDisplay: any = 100;
  public clientDisplay: any = 40;
  empID: any;
  agentID: any;
  constructor(private AgentEmployeeService: AgentEmployeeService) { }

  ngOnInit() {
    this.DbId = localStorage.getItem("dbId");
    this.empID = localStorage.getItem("EmployeeId");
    this.agentID = localStorage.getItem('AgentId');
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
      this.fxDisplay = 60;
      this.clientDisplay = 100;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
      this.fxDisplay = 100;
      this.clientDisplay = 40;
    }

    if (this.DbId == undefined || null) {
      this.getByEmployeeID();
    } else {
      this.getEmployeeByDbId();
    }

  }

  getByEmployeeID() {
    this.AgentEmployeeService.getByAgentEmployeeID(this.empID).subscribe(res => {
      this.employeeDetails = res[0];
    });
  }
  getEmployeeByDbId() {
    this.AgentEmployeeService.getagentemployeeby_id(this.DbId, this.agentID).subscribe(res => {
      this.employeeDetails = res.Vendors[0];
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    })
  }
  convertToDate(expirationDate) {
    if (expirationDate !== null && expirationDate !== '') {
      const expiration = new Date(expirationDate);
      if (expiration !== undefined) {
        return expiration.getMonth() + 1 + "/" + expiration.getDate() + "/" + expiration.getFullYear();
      }
      return expirationDate;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/employee-summary/employee-summary.component.ts